import _defineProperty from "/build/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";
import _asyncToGenerator from "/build/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _taggedTemplateLiteral from "/build/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/taggedTemplateLiteral.js";

var _templateObject;

import _regeneratorRuntime from "/build/node_modules/next/dist/compiled/@babel/runtime/regenerator/index.js";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import { gql } from "@apollo/client";
import { PLAYBACK_SESSION_ERROR_CODES, PLAYBACK_SESSION_ERROR_MESSAGES } from "@/lib/errors";
export var typeDef = gql(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  type Playback @cacheControl(scope: PRIVATE, maxAge: 0) {\n    media: PlaybackMedia\n    rule: PlaybackRule\n    playback_session_id: String\n    log_params: JSONObject\n    error: PlaybackError\n    mediaSource: JSONObject\n    resumePoint: Int\n    entitlements: [Entitlement]\n  }\n\n  type PlaybackMedia @cacheControl(scope: PRIVATE, maxAge: 0) {\n    media_id: ID!\n    uuid: String\n    ovp_id: Int\n    ovp_video_id: String\n    thumbnail_tile_urls: [String]\n  }\n\n  type PlaybackRule {\n    playback_rule_id: ID\n    enable_seek_flag: Boolean\n    enable_cromecst_flag: Boolean\n    enable_airplay_flag: Boolean\n    enable_mirroring_flag: Boolean\n    enable_external_monitor_flag: Boolean\n    enable_catchup_flag: Boolean\n    enable_start_over_flag: Boolean\n    enable_pause_flag: Boolean\n    enable_background_play_flag: Boolean\n    enable_screen_capture_flag: Boolean\n    enable_playback_rate_change_flag: Boolean\n    enable_offline_play_flag: Boolean\n    maximum_bitrate: Int\n    minimum_bitrate: Int\n  }\n\n  type PlaybackError {\n    type: String\n    message: String\n    code: Int\n  }\n\n  type MediaSource @cacheControl(maxAge: 0) {\n    media: JSONObject\n    error: PlaybackError\n  }\n\n  type PlaybackSessionCheckResult {\n    result: Boolean\n  }\n\n  type PlaybackSessionCloseResult {\n    result: Boolean\n  }\n\n  type Query {\n    playbackAuth(id: Int, vuid: String, sessionId: String, fl: Int): Playback\n  }\n\n  type Mutation {\n    playbackSessionOpen(videoId: String, sessionId: String): MediaSource\n    playbackSessionCheck(sessionId: String): PlaybackSessionCheckResult\n    playbackSessionClose(sessionId: String): PlaybackSessionCloseResult\n  }\n"])));
export var resolvers = {
  Query: {
    playbackAuth: function () {
      var _playbackAuth = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(_parent, _ref, _ref2) {
        var id, vuid, sessionId, fl, dataSources, playback, _yield$dataSources$us, entitlements;

        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                id = _ref.id, vuid = _ref.vuid, sessionId = _ref.sessionId, fl = _ref.fl;
                dataSources = _ref2.dataSources;
                _context.prev = 2;
                _context.next = 5;
                return dataSources.playbackAuth.auth({
                  id: id,
                  vuid: vuid,
                  sessionId: sessionId,
                  fl: fl,
                  withResumePoint: true,
                  exercise: true
                });

              case 5:
                playback = _context.sent;
                _context.next = 8;
                return dataSources.user.entitlementsFromMeta(id);

              case 8:
                _yield$dataSources$us = _context.sent;
                entitlements = _yield$dataSources$us.entitlements;
                return _context.abrupt("return", _objectSpread(_objectSpread({}, playback), {}, {
                  entitlements: entitlements
                }));

              case 13:
                _context.prev = 13;
                _context.t0 = _context["catch"](2);
                console.log("playback error", JSON.stringify(_context.t0.extensions, null, 2)); // TODO: 同時視聴制限などエラーハンドリング

                return _context.abrupt("return", _context.t0.extensions.response.body);

              case 17:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, null, [[2, 13]]);
      }));

      function playbackAuth(_x, _x2, _x3) {
        return _playbackAuth.apply(this, arguments);
      }

      return playbackAuth;
    }()
  },
  Mutation: {
    playbackSessionOpen: function () {
      var _playbackSessionOpen = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(_parent, _ref3, _ref4) {
        var videoId, sessionId, dataSources, mediaSource, _response$body, response, _response$body2, _response$body5, _response$body6, errorCode, _response$body3, _response$body4, _response$body7, _response$body8, _response$body9, _response$body10, message, code;

        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                videoId = _ref3.videoId, sessionId = _ref3.sessionId;
                dataSources = _ref4.dataSources;
                _context2.prev = 2;
                _context2.next = 5;
                return dataSources.playbackSession.open(videoId, sessionId);

              case 5:
                mediaSource = _context2.sent;
                return _context2.abrupt("return", {
                  media: mediaSource
                });

              case 9:
                _context2.prev = 9;
                _context2.t0 = _context2["catch"](2);
                console.log("playback session error", JSON.stringify(_context2.t0.extensions, null, 2));
                response = _context2.t0.extensions.response;

                if (!((response.status === 400 || response.status === 403) && response !== null && response !== void 0 && (_response$body = response.body) !== null && _response$body !== void 0 && _response$body.error)) {
                  _context2.next = 25;
                  break;
                }

                // エラーレスポンスに複数パターンがある?
                errorCode = Number((_response$body2 = response.body) === null || _response$body2 === void 0 ? void 0 : _response$body2.error);

                if (isNaN(errorCode)) {
                  _context2.next = 19;
                  break;
                }

                return _context2.abrupt("return", {
                  error: {
                    type: (_response$body3 = response.body) === null || _response$body3 === void 0 ? void 0 : _response$body3.type,
                    message: (_response$body4 = response.body) === null || _response$body4 === void 0 ? void 0 : _response$body4.message,
                    code: errorCode
                  }
                });

              case 19:
                if (!((response === null || response === void 0 ? void 0 : (_response$body5 = response.body) === null || _response$body5 === void 0 ? void 0 : _response$body5.result) === false && typeof (response === null || response === void 0 ? void 0 : (_response$body6 = response.body) === null || _response$body6 === void 0 ? void 0 : _response$body6.error) === "string")) {
                  _context2.next = 23;
                  break;
                }

                message = PLAYBACK_SESSION_ERROR_MESSAGES[PLAYBACK_SESSION_ERROR_CODES[response === null || response === void 0 ? void 0 : (_response$body7 = response.body) === null || _response$body7 === void 0 ? void 0 : _response$body7.error]] || (response === null || response === void 0 ? void 0 : (_response$body8 = response.body) === null || _response$body8 === void 0 ? void 0 : _response$body8.error);
                code = PLAYBACK_SESSION_ERROR_CODES[response === null || response === void 0 ? void 0 : (_response$body9 = response.body) === null || _response$body9 === void 0 ? void 0 : _response$body9.error] || PLAYBACK_SESSION_ERROR_CODES["other"];
                return _context2.abrupt("return", {
                  error: {
                    type: (_response$body10 = response.body) === null || _response$body10 === void 0 ? void 0 : _response$body10.type,
                    message: message,
                    code: code
                  }
                });

              case 23:
                _context2.next = 26;
                break;

              case 25:
                throw _context2.t0;

              case 26:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, null, [[2, 9]]);
      }));

      function playbackSessionOpen(_x4, _x5, _x6) {
        return _playbackSessionOpen.apply(this, arguments);
      }

      return playbackSessionOpen;
    }(),
    playbackSessionCheck: function () {
      var _playbackSessionCheck = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3(_parent, _ref5, _ref6) {
        var sessionId, dataSources, result;
        return _regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                sessionId = _ref5.sessionId;
                dataSources = _ref6.dataSources;
                _context3.next = 4;
                return dataSources.playbackSession.check(sessionId);

              case 4:
                result = _context3.sent;
                return _context3.abrupt("return", result);

              case 6:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3);
      }));

      function playbackSessionCheck(_x7, _x8, _x9) {
        return _playbackSessionCheck.apply(this, arguments);
      }

      return playbackSessionCheck;
    }(),
    playbackSessionClose: function () {
      var _playbackSessionClose = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee4(_parent, _ref7, _ref8) {
        var sessionId, dataSources, result;
        return _regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                sessionId = _ref7.sessionId;
                dataSources = _ref8.dataSources;
                _context4.prev = 2;
                _context4.next = 5;
                return dataSources.playbackSession.close(sessionId);

              case 5:
                result = _context4.sent;
                return _context4.abrupt("return", result);

              case 9:
                _context4.prev = 9;
                _context4.t0 = _context4["catch"](2);
                console.log(_context4.t0);
                return _context4.abrupt("return", false);

              case 13:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4, null, [[2, 9]]);
      }));

      function playbackSessionClose(_x10, _x11, _x12) {
        return _playbackSessionClose.apply(this, arguments);
      }

      return playbackSessionClose;
    }()
  },
  Playback: {
    rule: function rule(playback) {
      return playback.playback_rule;
    },
    resumePoint: function resumePoint(playback) {
      return playback.resume_point;
    }
  }
};